import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaintenanceModeComponent } from './components';

@NgModule({
  imports: [
    CommonModule,
    MaintenanceModeComponent,
  ],
  exports: [MaintenanceModeComponent],
})
export class MaintenanceModule {}
